/* eslint-disable no-unsafe-optional-chaining */
import { AlgoliaProvider, SearchState } from "@wise-emotions/react-algolia";
import { SearchProps } from "./types";
import { parse } from "qs";
import { useSiteContext } from "context/SiteProvider";
import React from "react";
import SearchFull from "components/Search/Full";

const PROJECT_ID = process.env.GATSBY_ALGOLIA_PROJECT_ID;
const SEARCH_API_KEY = process.env.GATSBY_ALGOLIA_SEARCH_API_KEY;
const INDEX_NAME = process.env.GATSBY_ALGOLIA_INDEX_NAME;

const Search = ({ page }: SearchProps) => {
  const { node_locale } = page;
  const translations = page?.settings[0]?.translations;
  const { title, text, image } = page?.content[0];
  const { state } = useSiteContext();

  const titleEmptySearch = title;
  // TODO: remark auto tag
  // const textEmptySearch = text?.childMarkdownRemark?.html;
  const textEmptySearch = text?.text;
  const imageEmptySearch = image?.[0];

  let query = "";
  if (typeof window !== "undefined" && window.location.search) {
    const obj = parse(window.location.search, { ignoreQueryPrefix: true });
    const { s: inputFromQs } = obj;
    if (typeof inputFromQs === "string") {
      query = inputFromQs;
    }
  }

  return (
    <AlgoliaProvider
      applicationId={PROJECT_ID}
      searchApiKey={SEARCH_API_KEY}
      indexName={INDEX_NAME}
      configureProps={{ hitsPerPage: 6, facetFilters: [`lang:${node_locale}`] }}
      minChars={state?.minCharsSearch ?? 0}
      searchState={query ? SearchState.DONE : SearchState.INITIAL}
    >
      <div className="SearchPage">
        <SearchFull
          title={titleEmptySearch}
          text={textEmptySearch}
          image={imageEmptySearch}
          translations={translations || []}
          lang={node_locale}
          query={query}
        />
      </div>
    </AlgoliaProvider>
  );
};

export default Search;
